import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { List } from "lucide-react";
import { UseFormReturn } from "react-hook-form";
import { User } from "@/hooks/useUsers";
import { useCompanies } from "@/hooks/useCompanies";
import { useAuth } from "@/hooks/useAuth";

interface UserTypeFieldProps {
  form: UseFormReturn<Omit<User, "id">>;
  isSuperAdmin: boolean;
  isAdmin: boolean;
}

export const UserTypeField = ({ form, isSuperAdmin, isAdmin }: UserTypeFieldProps) => {
  const { currentUser } = useAuth();
  const { companies } = useCompanies();
  
  // Check if user's company allows super_admin
  const userCompany = companies.find(company => company.id === currentUser?.companyId);
  const canCreateSuperAdmin = userCompany?.allow_super_admin || false;

  return (
    <FormField
      control={form.control}
      name="type"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Tipo de Usuário</FormLabel>
          <Select onValueChange={field.onChange} defaultValue={field.value}>
            <FormControl>
              <div className="relative">
                <List className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
                <SelectTrigger className="pl-8">
                  <SelectValue placeholder="Selecione o tipo" />
                </SelectTrigger>
              </div>
            </FormControl>
            <SelectContent>
              {isSuperAdmin && canCreateSuperAdmin && (
                <>
                  <SelectItem value="super_admin">Super Admin</SelectItem>
                  <SelectItem value="admin">Administrador</SelectItem>
                </>
              )}
              {isAdmin && !isSuperAdmin && (
                <SelectItem value="admin">Administrador</SelectItem>
              )}
              <SelectItem value="user">Usuário</SelectItem>
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};